import React from "react";
import NavBar from "../Utils/NavBar";
import FootBar from "../Utils/FootBar";
import { FaImages } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
require("../../assets/stylesheets/History/History.css");
const Feria21_3 = require("../../assets/images/results/2021-3/img1.png");
const Feria22_1 = require("../../assets/images/results/2022-1/img1.png");
const Feria22_2 = require("../../assets/images/results/2022-2/img1.png");

function PanelHistory() {

  const navigate = useNavigate();
  const ferias = [Feria21_3, Feria22_1, Feria22_2];
  const event = ["2021-3", "2022-1", "2022-2"];

  return (
    <div className="inSection">
      <div className="history">
        <div className="historyHeader">Feria Ingenio 2021-3</div>
        <div className="historyContent">
          <img src={ferias[0]} alt="Resultados Feria Ingenio 2021-3" />
          <Link to={`/history/${event[0]}`}><div className="btnHistory">Ver la historia <span className="galleryHistory"><FaImages /></span></div></Link>
        </div>
      </div>
      <div className="history">
        <div className="historyHeader">Feria Ingenio 2022-1</div>
        <div className="historyContent">
          <img src={ferias[1]} alt="Resultados Feria Ingenio 2022-1" />
          <Link to={`/history/${event[1]}`}><div className="btnHistory">Ver la historia <span className="galleryHistory"><FaImages /></span></div></Link>
        </div>
      </div>
      <div className="history">
        <div className="historyHeader">Feria Ingenio 2022-2</div>
        <div className="historyContent">
          <img src={ferias[2]} alt="Resultados Feria Ingenio 2022-2" />
          <Link to={`/history/${event[2]}`}><div className="btnHistory">Ver la historia <span className="galleryHistory"><FaImages /></span></div></Link>
        </div>
      </div>
    </div>
  );
}

function History() {
  return (
    <div className="main">
      <NavBar />
      <h2 id="historyTitle">Historia de las Ferias Ingenio</h2>
      <PanelHistory />
    </div>
  );
}

export default History;
